var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoDashboard01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_home_solid",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M23.5,30.5h-21c-2-0.1-3.6-1.7-3.5-3.7V11.1l-0.7,0.6c-0.3,0.3-0.7,0.4-1.1,0.4c-0.5,0-1.1-0.3-1.4-0.7 c-0.6-0.8-0.5-1.9,0.3-2.6L11.9-4.1c0.6-0.5,1.5-0.5,2.2,0L29.8,8.8c0.4,0.3,0.6,0.7,0.7,1.2c0.1,0.5-0.1,1-0.4,1.4 c-0.3,0.4-0.8,0.7-1.4,0.7c-0.4,0-0.8-0.1-1.1-0.4L27,11.1v15.7C27.1,28.8,25.5,30.5,23.5,30.5z M11.2,17.6c-1,0-1.8,0.9-1.8,1.8 v7.4h7v-7.4c0-1-0.8-1.8-1.8-1.8H11.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDashboard01);
export default __webpack_public_path__ + "static/media/ico-dashboard-01.061b71ec6e3a394577d1931f48f50c59.svg";
export { ForwardRef as ReactComponent };